/**
 * Generated runtime TestId mirror for frontend/src/pages/AutoAssignRuleRequestDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AutoAssignRuleRequestDetailTestIds = {
  affectedIdentitiesDialog: "affected-identities-dialog",
  approvalChainCard: "approval-chain-card",
  approveDialog: "approve-dialog",
  autoAssignRuleRequestDetailPage: "auto-assign-rule-request-detail-page",
  btnCloseAffected: "btn-close-affected",
  btnDelete: "btn-delete",
  btnEdit: "btn-edit",
  btnSubmitForApproval: "btn-submit-for-approval",
  btnTestRule: "btn-test-rule",
  btnViewAffected: "btn-view-affected",
  cardRequestDetails: "card-request-details",
  cardTitleAccessProfiles: "card-title-access-profiles",
  cardTitleApprovalChain: "card-title-approval-chain",
  cardTitleExpression: "card-title-expression",
  cardTitleWorkflow: "card-title-workflow",
  colAction: "col-action",
  colEnvironment: "col-environment",
  colIdentity: "col-identity",
  colName: "col-name",
  colParty: "col-party",
  colStatus: "col-status",
  colType: "col-type",
  deleteDialog: "delete-dialog",
  linkOwnerParty: "link-owner-party",
  noFunctionGroupsLinked: "no-function-groups-linked",
  noProfilesLinked: "no-profiles-linked",
  rejectDialog: "reject-dialog",
  submitDialog: "submit-dialog",
  testResultError: "test-result-error",
  testResultPanel: "test-result-panel",
  affectedRow: (item_identityId: string) => `affected-row-${item_identityId}`,
  affectedRowPrefix: () => "affected-row-" as TestIdPrefix,
  btnFilterAffected: (filter: string) => `btn-filter-affected-${filter}`,
  btnFilterAffectedPrefix: () => "btn-filter-affected-" as TestIdPrefix,
  escalationTimeline: (step_id: string) => `escalation-timeline-${step_id}`,
  escalationTimelinePrefix: () => "escalation-timeline-" as TestIdPrefix,
  linkAffectedIdentity: (item_identityId: string) => `link-affected-identity-${item_identityId}`,
  linkAffectedIdentityPrefix: () => "link-affected-identity-" as TestIdPrefix,
  linkAffectedParty: (item_partyId: string) => `link-affected-party-${item_partyId}`,
  linkAffectedPartyPrefix: () => "link-affected-party-" as TestIdPrefix,
  linkProfile: (profile_id: string) => `link-profile-${profile_id}`,
  linkProfilePrefix: () => "link-profile-" as TestIdPrefix,
  statusBadge: (request_status: string) => `status-badge-${request_status}`,
  statusBadgePrefix: () => "status-badge-" as TestIdPrefix
} as const;
